import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { message } from "antd";
import { toast } from "react-toastify";


// Async Thunk for creating a promo code
export const createPromoCode = createAsyncThunk(
	"promoCodes/createPromoCode",
	async (promoData, { rejectWithValue }) => {
		try {
			// Format dates to ISO format if needed
			const formattedData = {
				...promoData,
				start_date: new Date(promoData.start_date).toISOString(),
				end_date: new Date(promoData.end_date).toISOString(),
			};

			const response = await axios.post(`/promo-code`, formattedData, {
				headers: {
					'Content-Type': 'application/json',
				},
			});

			toast.success("Promo code created successfully!");
			return response.data;
		} catch (error) {
			// Show error details for debugging
			console.error("Error creating promo code:", error.response?.data || error.message);
			message.error(error.response?.data?.message || "Failed to create promo code");
			return rejectWithValue(error.response?.data || "Failed to create promo code");
		}
	}
);

const promoCodeSlice = createSlice({
	name: "promoCodes",
	initialState: {
		list: [],
		loading: false,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(createPromoCode.pending, (state) => {
				state.loading = true;
			})
			.addCase(createPromoCode.fulfilled, (state, action) => {
				state.loading = false;
				state.list.push(action.payload); // Add the new promo code to the list
			})
			.addCase(createPromoCode.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload || "Failed to create promo code";
			});
	},
});

export default promoCodeSlice.reducer;
